export default function Pagination({
  page,
  totalPages,
  total,
  onChange,
  testid = "pagination",
}) {
  if (total <= 0) return null;
  return (
    <div
      data-testid={testid}
      className="flex items-center justify-between px-4 py-3 border-t border-slate-100 text-sm"
    >
      <span className="text-slate-500">
        الإجمالي: {total} — صفحة {page} من {Math.max(1, totalPages)}
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          data-testid={`${testid}-prev`}
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
          className="px-3 py-1.5 bg-slate-100 hover:bg-slate-200 rounded-lg font-bold disabled:opacity-50 cursor-pointer"
        >
          السابق
        </button>
        <button
          type="button"
          data-testid={`${testid}-next`}
          disabled={page >= totalPages}
          onClick={() => onChange(page + 1)}
          className="px-3 py-1.5 bg-slate-100 hover:bg-slate-200 rounded-lg font-bold disabled:opacity-50 cursor-pointer"
        >
          التالي
        </button>
      </div>
    </div>
  );
}
